var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvatarOutlined = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Users / User"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0027 1.0415C7.81659 1.0415 6.04438 2.81371 6.04438 4.99984C6.04438 7.18596 7.81659 8.95817 10.0027 8.95817C12.1888 8.95817 13.961 7.18596 13.961 4.99984C13.961 2.81371 12.1888 1.0415 10.0027 1.0415ZM7.29438 4.99984C7.29438 3.50407 8.50694 2.2915 10.0027 2.2915C11.4985 2.2915 12.711 3.50407 12.711 4.99984C12.711 6.49561 11.4985 7.70817 10.0027 7.70817C8.50694 7.70817 7.29438 6.49561 7.29438 4.99984Z",
    fill: "#58607C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0027 10.2082C8.07476 10.2082 6.29849 10.6464 4.98226 11.3868C3.68562 12.1161 2.71105 13.2216 2.71105 14.5832L2.71099 14.6681C2.71005 15.6363 2.70887 16.8515 3.77473 17.7195C4.29928 18.1466 5.03311 18.4504 6.02456 18.6511C7.01877 18.8523 8.31457 18.9582 10.0027 18.9582C11.6909 18.9582 12.9867 18.8523 13.9809 18.6511C14.9723 18.4504 15.7061 18.1466 16.2307 17.7195C17.2966 16.8515 17.2954 15.6363 17.2944 14.6681L17.2944 14.5832C17.2944 13.2216 16.3198 12.1161 15.0232 11.3868C13.7069 10.6464 11.9307 10.2082 10.0027 10.2082ZM3.96105 14.5832C3.96105 13.8737 4.47886 13.1041 5.59508 12.4763C6.69171 11.8594 8.24878 11.4582 10.0027 11.4582C11.7567 11.4582 13.3137 11.8594 14.4103 12.4763C15.5266 13.1041 16.0444 13.8737 16.0444 14.5832C16.0444 15.673 16.0108 16.2865 15.4414 16.7502C15.1326 17.0016 14.6164 17.2471 13.7329 17.4259C12.8521 17.6042 11.6479 17.7082 10.0027 17.7082C8.35753 17.7082 7.15333 17.6042 6.27254 17.4259C5.38899 17.2471 4.87281 17.0016 4.56404 16.7502C3.99465 16.2865 3.96105 15.673 3.96105 14.5832Z",
    fill: "#58607C"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvatarOutlined);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar_outlined.20d2f456280f9db14edf157e427a03a2.svg";